import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import SEO from '../../components/SEO';
import NavExpander from '../../containers/NavExpander';
import ToolTips from '../../containers/ToolTips';
import Recirc from '../../components/Recirc';
import InterviewsArtwork from '../../components/PageArtwork/InterviewsArtwork';
import PageContent from './PageContent';
import styles from './page.css';

const Interview = ({ path, header, title, description, content, recircPost, image }) => {
  return (
    <div className={styles.page}>
      <SEO title={title} description={description} path={path} image={image} />
      <NavExpander>
        <section className={styles.wrapper}>
          <div className={`${styles.content} artist`}>
            <InterviewsArtwork />
            <ToolTips>
              <PageContent header={header} content={content} />
            </ToolTips>
            {recircPost && (
              <Recirc
                subtitle="Interviews"
                title={recircPost.title.replace('&#038;', '&')}
                link={recircPost.path}
              />
            )}
          </div>
        </section>
      </NavExpander>
    </div>
  );
};

Interview.propTypes = {
  path: PropTypes.string.isRequired,
  header: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  recirc: PropTypes.object.isRequired,
  recircPost: PropTypes.object,
  image: PropTypes.string,
};

export default withRouter(Interview);
